<template>
  <div>
    <search-form ref="form" @search="handleSearch">
      <el-button type="primary" @click="handleSearch" :loading="searching">{{ $t('common.search') }}</el-button>
    </search-form>

    <el-card v-loading="searching">
      <el-button type="primary" @click="handleAdd">{{ $t('singer.create') }}</el-button>

      <br>
      <br>

      <div class="singer-group">
        <div v-for="item in tableData" class="singer-item" :key="item.id">
          <el-popover
            v-model="item.isShow"
            :disabled="!(item.albumList && item.albumList.length > 0)"
            popper-class="popper-albums"
            placement="right-start"
            width="226"
            trigger="hover"
          >
            <div v-if="item.albumList && item.albumList.length > 0" class="singer-albums">
              <p>{{ $t('singer.twoNewestAlbum') }}</p>
              <div v-for="(album, key) in item.albumList" :key="key" class="singer-album-item">
                <div :style="{backgroundImage: `url(${album.photoUrl})`}" class="singer-album-pic" />
                <div class="singer-album-info">
                  <p>
                    <auto-tip-text :show="item.isShow" :content="`${ $t('album.albumName') }：${ album.albumName }`"></auto-tip-text>
                  </p>
                  <p class="singer-album-public-time">
                    <span class="label">{{ $t('common.publicTime') }}：</span>
                    <span>{{ album.publicTime }}</span>
                  </p>
                </div>
              </div>
            </div>

            <div v-if="item.photoUrl" slot="reference" class="singer-pic" :style="{backgroundImage: `url(${item.photoUrl})`}" />
            <div v-else class="singer-pic empty" slot="reference" />
          </el-popover>
          <div class="singer-info">
            <auto-tip-text class="singer-name" :content="`${ $t('common.singerName') }：${ item.singerName }`"></auto-tip-text>
            <auto-tip-text :content="`翻译名：${ item.transName }`"></auto-tip-text>
            <auto-tip-text :content="`活跃地区：${ areaMap[item.area] }`"></auto-tip-text>
            <auto-tip-text :content="`${ $t('singer.type') }：${ $t(`singer.singerTypeMap[${item.type}]`) }`"></auto-tip-text>
          </div>
        </div>
      </div>

      <Empty v-if="!tableData.length">
        <template v-if="!init">{{ $t('common.empty') }}</template>
      </Empty>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="fetchData"
        :current-page.sync="pagination.current"
        :page-sizes="[21, 50, 100, 1000, 2000]"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>
    <edit v-if="showAdd" @cancel="handleCloseAdd" @search="handleSearchSinger"></edit>
  </div>
</template>

<script>
import singerService from '@/api/actor'
import {
  actorTypeMap,
  areaMap,
} from './mixin.js'
import Edit from './edit'
import SearchForm from './components/SearchForm.vue'
import AutoTipText from '@/components/AutoTipText/index.vue'
import Empty from '@/components/Empty/index.vue'

export default {
  name: 'SingerList',
  components: {
    Edit,
    Empty,
    SearchForm,
    AutoTipText
  },
  data() {
    return {
      actorTypeMap,
      areaMap,
      // searchForm: {
      //   singerName: '',
      //   type: ''
      // },
      tableData: [],
      pagination: {
        current: 1,
        size: 21,
        total: 0
      },
      init: false,
      searching: false,
      showAdd: false
    }
  },

  methods: {
    fetchData() {
      const { pagination } = this
      const postData = {
        page: pagination.current - 1,
        num: pagination.size,
        ...this.$refs.form.searchForm
      }

      if (postData.singerName === '') {
        return this.$message({
          type: 'warning',
          message: '请输入艺人名搜索'
        })
      }

      this.searching = true
      singerService.find(postData).then(resp => {
        this.pagination.total = resp.total
        this.tableData = resp.list.map(val => ({
          ...val,
          isShow: false
        }))
      }).catch(error => {
        console.log(error)
        this.$message({
          type: 'error',
          message: `查询异常：${error.message}`
        })
      }).finally(_ => {
        this.searching = false
        this.init = true
      })
    },

    handleAdd() {
      this.showAdd = true
    },

    handleSearch() {
      this.pagination.current = 1

      this.fetchData()
    },

    handleSizeChange(size) {
      this.pagination.size = size
      this.fetchData()
    },

    handleCloseAdd(refresh) {
      this.showAdd = false

      if (refresh) {
        this.handleSearch()
      }
    },

    handleSearchSinger(singerName) {
      this.$refs.form.searchForm.singerName = singerName
      this.handleSearch()
    }
  }
}
</script>

<style scoped lang="scss">
.table-detail {
  border-top: 1px solid #ccc;
  padding: 4px;

  &:last-child {
    border-bottom: 1px solid #ccc;
  }

  .el-col {
    line-height: 50px;
  }

}
/deep/ .el-table__expanded-cell {
  background-color: rgba(#f0f2f5, 0.5)
}

.el-card::v-deep {
  .el-card__body {
    padding: 20px;
  }
}

.singer-group {
  display: flex;
  flex-wrap: wrap;
}

.singer-item {
  width: 132px;
  height: 205px;
  background: #E3E2EB;
  box-shadow: 0px 6px 6px rgba(204,188,220,0.05);
  opacity: 1;
  border-radius: 4px 4px 0px 0px;
  margin: 0 13px 13px 0;
  padding: 6px;
  &:nth-child(7n) {
    margin-right: 0;
  }
}

.singer-pic {
  height: 118px;
  background-size: cover;
  background-position: center;
  position: relative;
  &.empty {
    background-size: cover;
    background-position: center;
    background-image: url("~@/assets/default_img.png");
    position: relative;
    &::before {
      content: '暂无图片';
      color: #fff;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  &:not(.empty) {
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      background-color: #000;
      transition: opacity 0.3s ease-in-out;
    }
    &:hover {
      &::before {
        opacity: 0.5;
      }
    }
  }
}

.singer-info {
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  font-size: 12px;
  .singer-name {
    font-weight: 600;
  }
}

.singer-albums {
  padding: 10px;
  & > p {
    color: #002444;
    font-size: 12px;
  }
}

.singer-album-item {
  display: flex;
  margin: 10px 0 16px;
  font-size: 12px;
  color: #002444;
  cursor: pointer;
  .singer-album-pic {
    width: 64px;
    height: 64px;
    background-size: cover;
    background-position: center;
    margin-right: 6px;
  }

  .singer-album-info {
    width: 132px;
    p {
      margin-top: 4px;
      line-height: 16px;
    }
  }
}

.singer-album-public-time {
  display: flex;

  span {
    width: 70px;
  }
  span.label {
    width: 60px;
  }
}

.singer-album-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
